import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4707cc57"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "classcatalogue-container" }
const _hoisted_2 = { class: "inspection-list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "stepLeft" }
const _hoisted_5 = { class: "stepIcon" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  style: {"border-left":"solid 1px #969799"},
  class: "stepLine"
}
const _hoisted_9 = { class: "stepRight" }
const _hoisted_10 = { class: "stepTitle" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepText" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList, (li, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: "step",
          onClick: ($event: any) => (
          _ctx.$router.push({
            path: '/app/identify',
            query: {
              videoId: li.videoId,
              id: _ctx.$route.query.id,
              classId: li.classId,
              itemId: li.id,
            },
          })
        )
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (li.isFinish === 1)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "step-image",
                    src: require('@/assets/courselearn/finished.png')
                  }, null, 8, _hoisted_6))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "step-image",
                    src: require('@/assets/courselearn/unfinished.png')
                  }, null, 8, _hoisted_7))
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [
              [_vShow, _ctx.classList.length - 1 !== i]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(i + 1) + "." + _toDisplayString(li.name), 1),
            _hoisted_11
          ])
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}